/**
 * Component - certificateList
 */

export const certificateList = ():void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-certificateList') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {

  })
}
